import changeObjectKeysCamelToUnderscore from '../../../utils/changeObjectKeysCamelToUnderscore';
import Optional from '../../../utils/optional';

export default function mapScheduleForUpdate({ tableSchedules }) {
  return tableSchedules.map(schedule => {
    const { action, eventSchedule, name } = schedule;
    const mapppedAction = changeObjectKeysCamelToUnderscore(action);
    const mapppedEventSchedule = changeObjectKeysCamelToUnderscore(
      eventSchedule
    );

    return {
      name,
      action: mapppedAction,
      event_schedule: mapppedEventSchedule
    };
  });
}
